import(/* webpackMode: "eager" */ "/home/runner/work/demos/demos/vendir-packages/services/auth-app/src/app/global-error.tsx");
